import React, { useContext, useState, useEffect } from 'react';
import ProjectsListCard from '/src/Components/ProjectsListCard/ProjectsListCard';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { CircleSlash2 } from 'lucide-react';
import { AddressSearchContext, WindowSizeContext } from '/src/App';
import CTAButton from '/src/Components/CTAButton/CTAButton';

import './style.css';

const Discounts = ({ propertyData, userPlanSelection, discounts, companies, projects, handleGoToCompeteOverMe }) => {

    const { deviceType } = useContext(WindowSizeContext);

    // Get the portalData from the AddressSearchContext
    const { portalData } = useContext(AddressSearchContext);

    // Load the user and icons from local storage
    const user = JSON.parse(localStorage.getItem('user'));
    const icons = portalData.icons || {};

    // Set the state for the next steps step the user is on
    const [nextStepsStep, setNextStepsStep] = useState(1);
    const [nextStepsStepContent, setNextStepsStepContent] = useState(null);

    // Get the user's insurance provider, preferred retailers, and preferred service providers
    const userInsuranceProviderId = user.insuranceProvider || null;
    const userPreferredRetailersIds = user.preferredRetailers || [];
    const userPreferredServiceProvidersIds = user.preferredServiceProviders || [];

    // Get the combined preferred ids
    const userCombinedPreferredIds = [userInsuranceProviderId, ...userPreferredRetailersIds, ...userPreferredServiceProvidersIds];

    // Map through the preferred companies and add the icon to the company, using the icon key as a lookup key in the icons object
    const companiesWithIcons = companies.map(company => {
        const icon = icons[company.icon];
        return { ...company, icon_path: icon };
    });

    // Filter the companies to get the user's insurance provider
    const userInsuranceProvider = companiesWithIcons.find(company => company.id === userInsuranceProviderId) || null;

    // Get a boolean value for whether we found the user's insurance provider
    const doWeKnowYourInsuranceProvider = userInsuranceProvider !== null;
    // console.log('userInsuranceProvider', userInsuranceProvider);
    // console.log('doWeKnowYourInsuranceProvider', doWeKnowYourInsuranceProvider);


    // Get the projects in the plan
    const planProjects = userPlanSelection.projectData || [];
    const planProjectsCount = planProjects.length;

    // Get the project data for each project in the plan and add the diyPreference to the project data
    const planProjectsWithDiyPreference = planProjects.map(planProject => {
        const projectData = projects.find(p => p.project_id === planProject.project_id);
        return { ...projectData, diyPreference: planProject.diyPreference };
    }).sort((a, b) => {
        const aLength = a.project_discounts_company_specific?.length || 0;
        const bLength = b.project_discounts_company_specific?.length || 0;
        return bLength - aLength; // Sort in descending order (most discounts first)
    });

    // Map through the planProjectsWithDiyPreference and collect all of the objects from the project_discounts_company_specific array INTO A SINGLE ARRAY
    const projectDiscountsCompanySpecific = planProjectsWithDiyPreference.flatMap(project => project.project_discounts_company_specific);

    // Get the unique entity_id values from the projectDiscountsCompanySpecific array
    const uniqueEntityIds = [...new Set(projectDiscountsCompanySpecific.map(item => item.entity_id))];

    // Get the ids of any companies that have more than 1 discount in the projectDiscountsCompanySpecific array
    const companiesWithMultipleDiscounts = projectDiscountsCompanySpecific.filter(item => item.entity_id).map(item => item.entity_id);
    console.log('companiesWithMultipleDiscounts', companiesWithMultipleDiscounts);

    // Get the companies that the discounts are from, filtering the companiesWithIcons array for the companies that have an id in the uniqueEntityIds array
    const companiesOfferingDiscounts = companiesWithIcons.filter(company => uniqueEntityIds.includes(company.id));

    // Determine whether the userInsuranceProviderId is in the companiesOfferingDiscounts array
    const isInsuranceProviderOfferingDiscounts = companiesOfferingDiscounts.some(company => company.id === userInsuranceProviderId);

    console.log('isInsuranceProviderOfferingDiscounts', isInsuranceProviderOfferingDiscounts);

    // Get the companie
    console.log('uniqueEntityIds', uniqueEntityIds);

    console.log('planProjectsWithDiyPreference', planProjectsWithDiyPreference);

    const discountsIntroSentence = "Taking steps to increase your resilience interests a lot of groups and gives you a lot of power, even when there aren’t clear discounts available. Here is what we recommend you do next:";
    // const discountsIntroSentence = "There are a lot of groups that are interested in your resilience projects. Home improvement companies want to sell you the actual goods and services, insurance companies want you as a customer now that you are less risky, and government agencies want to incentivize resilience and sustainability.  This gives you a lot of power in this moment, which can be leverages to unlock discounts and incentives that will make these improvements less costly today and increase the benefit to you over time. ";

    let discountsPreDiscountSplashSentence = "";
    if (companiesOfferingDiscounts.length > 0) {
        discountsPreDiscountSplashSentence = `For the projects in your plan, we've identified the following groups offering discounts and incentives:`;
    } else {
        discountsPreDiscountSplashSentence = "Unfortunately, we don't see any discounts or incentives for the projects in your plan. But don't worry, we are constantly adding new offers we find, and in the meantime see below for what we'd suggest you do to maximize your savings.";
    }

    let discountsPostDiscountSplashSentence = "";
    if (companiesOfferingDiscounts.length > 0) {
        discountsPostDiscountSplashSentence = `We are also constantly adding new discounts and incentives we find, and are in the process of automating those discounts directly into the platform.`;
    } else {
        discountsPostDiscountSplashSentence = "Unfortunately, we don't see any discounts or incentives for the projects in your plan. But don't worry, we are constantly adding new offers we find, and in the meantime here is what we'd suggest you do to maximize your savings:";
    }


    const formatBenefitText = (discount, companyType) => {
        const isInsurance = companyType === "Insurance";
        const suffixText = isInsurance ? "Est. Premium Discount" : "Off";

        switch (discount.discount_value_type) {
            case "est_discount_percentage":
                return {
                    value: `${(discount.est_discount_percentage * 100).toFixed(0)}%`,
                    suffix: suffixText
                };
            case "est_discount_dollars":
                return {
                    value: `$${discount.est_discount_dollars.toLocaleString()}`,
                    suffix: suffixText
                };
            default:
                return { value: "", suffix: "" };
        }
    };

    // Call Your Insurance Provider

    const userInsuranceProviderName = userInsuranceProvider?.name || "Your Insurance Provider";
    const userInsuranceProviderIcon = userInsuranceProvider?.icon_path || null;
    const userInsuranceProviderIconPath = userInsuranceProviderIcon ? CreateCloudfrontUrl(userInsuranceProviderIcon) : null;

    const callYourInsuranceProviderHeader = `Call ${userInsuranceProviderName}`;
    let callYourInsuranceProviderSentence = "";
    if (doWeKnowYourInsuranceProvider && userInsuranceProvider) {

        if (isInsuranceProviderOfferingDiscounts) {
            callYourInsuranceProviderSentence = `${userInsuranceProvider.name} has discounts that match your projects so this is a good place to start. Give your agent a call to verify the discounts (be specific about the projects!), and see if they have any other offers we may have missed. Feel free to casually mention that you may be inclined to shop your new resilience around the market...`;
        } else {
            callYourInsuranceProviderSentence = `Even though we don't see any offers from ${userInsuranceProvider.name}, they are highly incentivized to do what they need to keep you. Explain the work you are doing (be specific!) and ask what they can do to keep you as a customer.`;
        }
    } else {
        callYourInsuranceProviderSentence = "Call your current insurance provider, explain the work that you are doing (be specific!), and ask if they offer any discounts for the projects in your plan. Don't assume that just because they don't list offers, doesn't mean they don't have any available. Feel free to casually mention that you may be inclined to shop your new resilience around the market...";
    }

    const dummyHandleProjectClick = (project) => {
        return;
    }

    // Shop Around Anyways
    const shopAroundAnywaysHeader = "Shop Around For Better Offers";
    const shopAroundAnywaysSentence = "Even if your current providers have available offers, they may not be the best you can get. Taking action to become more resilient makes you highly valuable across the market, so take advantage of it!";

    // Have Quoll do it for you
    const haveQuollDoItForYouHeader = "Have Quoll Do It For You";
    const haveQuollDoItForYouSentence = "Wouldn’t it be great if companies came to you with these offers instead of having to chase them? Well, we have a way to do just that, all while protecting your personal information and keeping you off of unwanted spam lists...";


    const nextStepsArray = [
        {
            step: 1,
            id: "call-current-provider",
            header: callYourInsuranceProviderHeader,
            sentence: callYourInsuranceProviderSentence,
            icon: userInsuranceProviderIconPath
        },
        {
            step: 2,
            id: "shop-around-anyways",
            header: shopAroundAnywaysHeader,
            sentence: shopAroundAnywaysSentence,
            icon: null
        },
        {
            step: 3,
            id: "have-quoll-do-it-for-you",
            header: haveQuollDoItForYouHeader,
            sentence: haveQuollDoItForYouSentence,
            icon: null
        }
    ]

    useEffect(() => {
        setNextStepsStepContent(nextStepsArray.find(step => step.step === nextStepsStep));
    }, [nextStepsStep]);

    // Get the projects that have discounts
    const projectsWithDiscounts = planProjectsWithDiyPreference.filter(project => project.project_discounts_company_specific.length > 0);
    const projectsWithoutDiscounts = planProjectsWithDiyPreference.filter(project => project.project_discounts_company_specific.length === 0);

    const discountsFirstHeader = "Discounts Identified";

    return (
        <div className="taking-action-section-container">
            <div className="taking-action-subsection-container">
                <h1>{discountsFirstHeader}</h1>
                {discountsPreDiscountSplashSentence &&
                    <p className="discounts-pre-discount-splash-sentence text-align-center" dangerouslySetInnerHTML={{ __html: discountsPreDiscountSplashSentence }} />
                }
                <div className="discounts-projects-with-discounts-container">
                    {projectsWithDiscounts.map(project => (
                        <div className="discounts-projects-with-discounts-individual-project-container">
                            <ProjectsListCard
                                key={project.project_id}
                                project={project}
                                showAllDetails={false}
                                handleProjectClick={dummyHandleProjectClick}
                            />
                            <div className="discounts-projects-with-discounts-individual-project-discounts-container">
                                {project.project_discounts_company_specific.length > 0 ? project.project_discounts_company_specific.map(discount => {

                                    // Get the company from the companiesOfferingDiscounts array
                                    const company = companiesOfferingDiscounts.find(company => company.id === discount.entity_id);
                                    const companyType = company.company_type;
                                    const benefit = formatBenefitText(discount, companyType);
                                    return (
                                        <div className="discounts-projects-with-discounts-individual-project-discount-container">
                                            <div className="discounts-projects-with-discounts-individual-project-discount-logo-container">
                                                <img src={CreateCloudfrontUrl(company.icon_path)} alt={company.name} />
                                            </div>
                                            <div className="discount-benefit">
                                                <p className="benefit-value">{benefit.value}</p>
                                                <p className="discounts-projects-with-discounts-individual-project-discount-benefit-suffix">{benefit.suffix}</p>
                                            </div>
                                        </div>
                                    )
                                }) : (
                                    <div className="discounts-projects-no-discounts-found-icon-container">
                                        <CircleSlash2 />
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                    {projectsWithoutDiscounts.length > 0 && (
                        <div className="discounts-projects-without-discounts-container">
                            <div className="discounts-projects-without-discounts-projects-container">
                                {projectsWithoutDiscounts.map(project => (
                                    <div className="discounts-projects-with-discounts-individual-project-container">
                                        <ProjectsListCard
                                            key={project.project_id}
                                            project={project}
                                            showAllDetails={false}
                                            handleProjectClick={dummyHandleProjectClick}
                                        />
                                    </div>
                                ))}
                            </div>
                            <div className="discounts-projects-no-discounts-found-icon-container">
                                <CircleSlash2 />
                            </div>
                            <span>No discounts found</span>
                        </div>
                    )}

                </div>
                {/* <p className="discounts-post-discount-splash-sentence text-align-center" dangerouslySetInnerHTML={{ __html: discountsPostDiscountSplashSentence }} /> */}
            </div>
            <div className="taking-action-subsection-container">
                <h1>Next Steps</h1>
                <p className="discounts-intro-sentence text-align-center" dangerouslySetInnerHTML={{ __html: discountsIntroSentence }} />

                <div className={`discounts-next-steps-toggle ${deviceType}`}>
                    {nextStepsArray.map(step => (
                        <div className={`discounts-next-steps-toggle-item ${deviceType} ${nextStepsStep === step.step ? 'active' : 'inactive'}`} onClick={() => setNextStepsStep(step.step)}>
                            <h4 className="discounts-next-steps-toggle-item text-align-center">{step.header}</h4>
                        </div>
                    ))}
                </div>
                {nextStepsStepContent && (
                    <div className={`discounts-next-step-container ${deviceType}`}>
                        <div className="discounts-next-step-header-container">
                            <h3 className="discounts-next-step-header text-align-center">{nextStepsStepContent.header}</h3>
                        </div>
                        <div className="discounts-next-step-content-container">
                            <div className={`discounts-next-step-content-container-row ${deviceType}`}>
                                {nextStepsStepContent.icon && (
                                    <div className="discounts-next-step-icon-container">
                                        <img src={nextStepsStepContent.icon} alt={nextStepsStepContent.header} />
                                    </div>
                                )}
                                <p className="discounts-next-step-sentence text-align-center">{nextStepsStepContent.sentence}</p>
                            </div>
                            {nextStepsStepContent.step === 3 && (
                                <CTAButton onClick={handleGoToCompeteOverMe} text={'Have Companies Compete Over You'} />
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Discounts;